/**
 * Feature toggles for the web app.
 *
 * Each toggle is a compile-time constant that guards UI elements.
 * - `false` → feature hidden, code tree-shaken from production builds
 * - `true`  → feature visible
 *
 * Naming: ENABLE_ prefix + SCREAMING_SNAKE_CASE
 * Default: always `false` for new toggles
 *
 * @see docs/feature-toggles.md for the full guide
 */

/** Notification bell in all navbars + notifications menu link. */
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const ENABLE_NOTIFICATIONS: boolean = false;

/** V2 Users API — new UUID-based endpoints (ENB-1610). Set true once backend deploys to all environments. */
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const ENABLE_USERS_V2_API: boolean = false;

/** Registered Absences list page (/absence-list). Hidden for Stockholm Stad launch. */
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const ENABLE_ABSENCE_LIST: boolean = false;

/**
 * Passenger date of birth editable without the Superuser role (ENB-2387).
 * ENB-2355 states date of birth is editable by the user, but the deployed backend rejects the
 * change for anyone without SUPERUSER. Set true once the backend permission is aligned.
 */
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const ENABLE_NON_SUPERUSER_DATE_OF_BIRTH_EDIT: boolean = false;
